module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "500px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Add to Pairing Influencer")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-autocomplete', {
    attrs: {
      "filled": "",
      "items": _vm.campaigns,
      "label": "Select Campaign",
      "item-value": "id",
      "hide-details": "",
      "item-text": "name"
    },
    model: {
      value: (_vm.selectedCampaign),
      callback: function($$v) {
        _vm.selectedCampaign = $$v
      },
      expression: "selectedCampaign"
    }
  }), _vm._v(" "), _c('v-row', {
    staticClass: "pt-2"
  }, [_c('v-col', [_c('v-list-item', {
    staticClass: "pa-0"
  }, [_c('v-list-item-content', _vm._l((_vm.selectedInfluencers), function(inf, index) {
    return _c('v-list-item-subtitle', {
      key: index
    }, [_c('v-icon', {
      attrs: {
        "color": "green",
        "small": ""
      }
    }, [_vm._v("mdi-check")]), _vm._v(" "), (inf.platform === 'tiktok') ? _c('a', {
      attrs: {
        "target": "_blank",
        "href": 'https://www.tiktok.com/@' + inf.instagramHandle
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/img/tiktok-32.png",
        "width": "20px"
      }
    }), _vm._v(" @" + _vm._s(inf.instagramHandle))]) : _c('a', {
      attrs: {
        "target": "_blank",
        "href": 'https://instagram.com/' + inf.instagramHandle
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "#000000",
        "small": ""
      }
    }, [_vm._v("mdi-instagram")]), _vm._v(" @" + _vm._s(inf.instagramHandle))], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" Close ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "success",
    attrs: {
      "disabled": !_vm.selectedCampaign
    },
    on: {
      "click": _vm.addtoPairing
    }
  }, [_vm._v("Save changes")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('full-screen-progress', {
    attrs: {
      "show": _vm.bulkProgress.show,
      "isStatus": "true",
      "processing": _vm.bulkProgress.processing,
      "complete": _vm.bulkProgress.complete,
      "color": _vm.secondary
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3baff7b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Influencer/AddInfluencerPairingModal.vue
// module id = 2081
// module chunks = 0